// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2143":"app","8918":"app-embed"}[chunkId] + "." + {"2143":"a73a04e3","8918":"072ee8bf"}[chunkId] + ".chunk.css";
};